<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      <div class="col-xs-12 col-md-6 d-flex gap-1">
        <pr-input-radio
          formControlName="venteEnPresenceDesParties"
          columns="2"
          [toggle]="true"
          [isDefault]="false"
          label="Vente en présence des parties"
        >
        </pr-input-radio>
        <pr-tooltip-icon tooltip="Vente en présence des parties" />
      </div>
      <div class="col-xs-12 col-md-6 d-flex gap-1">
        <pr-input-radio
          formControlName="clientPresentAuMomentIdentification"
          columns="2"
          [toggle]="true"
          [isDefault]="false"
          label="Client présent au moment de son identification"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Le client est physiquement présent aux fins de l'identification. "
        />
      </div>
    </div>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
